import { render, staticRenderFns } from "./TabResponsiveButton.vue?vue&type=template&id=245b68e9&"
import script from "./TabResponsiveButton.vue?vue&type=script&lang=js&"
export * from "./TabResponsiveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports